/**
 * @author yeyuchao
 * @description join us.
 */
const screenHeight = window.screen.height;
const screenWidth = window.screen.width;

export default {
  data() {
    return {
      screenHeight:screenHeight,
      screenWidth:screenWidth,
    };
  },
  mounted() {
  },
  created() {
    if(!window.loadComplete){
      this.$router.push('/');
      return
    }
  },
  methods:{
    closeFeature(){
      this.$router.push('/elabDo');
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/feature/feature.js